// extracted by mini-css-extract-plugin
module.exports = {"container":"AuditModal_container__dSehP","tips":"AuditModal_tips__mbtp5","item":"AuditModal_item__1nFmg","label":"AuditModal_label__2gOYp","val":"AuditModal_val__2gpQF"};